import { render, staticRenderFns } from "./DetailedInfo.vue?vue&type=template&id=4c4d7b50&scoped=true"
import script from "./DetailedInfo.vue?vue&type=script&lang=ts"
export * from "./DetailedInfo.vue?vue&type=script&lang=ts"
import style0 from "./DetailedInfo.vue?vue&type=style&index=0&id=4c4d7b50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4d7b50",
  null
  
)

export default component.exports